// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength,padString) {
        targetLength = targetLength>>0; //floor if number or convert non-number to 0;
        padString = String(padString || ' ');
        if (this.length > targetLength) {
            return String(this);
        }
        else {
            targetLength = targetLength-this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength/padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0,targetLength) + String(this);
        }
    };
}




import Vue from 'vue'
import App from './App'
import {store} from './store.js'

//import router based on the environment (dev/prod)
let router;
if (process.env.NODE_ENV === 'development') {
    router = require('./router/indexDev.js').default;
} else {
    router = require('./router/index.js').default;
}

import tdLocalStorage from './tdLocalStorage'
import tdApi from './tdApi'
import {EventBus} from './eventBus.js';
import tdSupportChat from './tdSupportChat.js';

import { tdTranslations, tdTranslationsEventTypes, translate, translateEventTypes } from './tdVueTranslations.js';

import VueLodash from 'vue-lodash'

import tdMobileNotificationsUtil from "./components/userNotifications/components/tdMobileNotificationsUtil.js";


const options = { name: 'lodash' }; // customize the way you want to call it
Vue.use(VueLodash, options); // options is optional

// route guards / login request
router.beforeEach((to, from, next) => {
    //DEV Only - external login (google, microsoft, etc) - for local testing
    if (window.tdDeployInject && window.tdDeployInject.deployType === 'dev' && to.name === 'dashboardRoute') {
        let urlParts = window.location.href.split('?');

        if (urlParts[1] !== undefined) {
            let urlParams = new URLSearchParams(urlParts[1]);

            if (urlParams.has('session_token') && urlParams.has('session_company_id')) {
                tdLocalStorage.set('td_remember_login_new', {
                    'session_token': urlParams.get('session_token'),
                    'session_company_id': urlParams.get('session_company_id')
                });

                //Mobile notifications
                tdMobileNotificationsUtil.sendLoginEvent();
            }
        }
    }

	if (
        (to.path.includes('/locationCheckIn/') || to.path === '/locationCheckIn') ||
        (to.path.includes('/teamInfoPage/') || to.path === '/teamInfoPage') ||
        (to.path.includes('/teamInfoReport') || to.path === '/teamInfoReport') ||
        (to.path.includes('/privacyPolicy/') || to.path === '/privacyPolicy') ||
        (to.path.includes('/requestInformation/') || to.path === '/requestInformation') ||
        (to.path.includes('/login/') || to.path === '/login') || // allow extra params to the url (/login/ro_RO)
        (to.path.includes('/loginRfid/') || to.path === '/loginRfid') || // allow extra params to the url (/loginRfid/ro_RO)
        (to.path.includes('/dashboardRfid/') || to.path === '/dashboardRfid') || // allow extra params to the url dashboard for (/loginRfid/ro_RO)
        (to.path.includes('/myProfile/') || to.path === '/myProfile') || // allow extra params to the url dashboard for (/loginRfid/ro_RO)
        (to.path.includes('/registerCompany/') || to.path === '/registerCompany') || // allow extra params to the url (/registerCompany/ro_RO)
        (to.path.includes('/recover/') || to.path === '/recover') || // allow extra params to the url (/recover/ro_RO)
        (to.path.includes('/reset/') || to.path === '/reset') ||
        (to.path.includes('/loginEfactura/') || to.path === '/loginEfactura') ||
        (to.path.includes('/registerCompanyEfactura/') || to.path === '/registerCompanyEfactura') ||
        (to.path.includes('/passwordRecoverEfactura/') || to.path === '/passwordRecoverEfactura'))
    {

        // set the company language
        //todo - temporary hardcoded to Romanian, to be modified in the future
        //store.commit('setCompanyLanguage', 'ro_RO');
        // if (to.params !== undefined && to.params.language !== undefined) {
        //     store.commit('setCompanyLanguage', to.params.language);
        // } else {
        //     store.commit('setCompanyLanguage', 'en_US');
        // }
        if ( to.path.includes('login') || to.path.includes('registerCompanyRoute') || to.path.includes('mainEfacturaRoute') ) {
            tdSupportChat.hideChat();
        }

        next();
    } else {
        console.log('Route guard - You need to login to access this page');

        /**
         * NOTE
         * check activity/eventDetails.vue for "event from a different company, change td_remember_login and reload page"
         */

        if (store.getters.isLoggedIn === false) {
            // check if we have stored remember login
            let rememberLogin = tdLocalStorage.get('td_remember_login_new');

            if (rememberLogin !== null) {


                let registerApiCall = new tdApi('auth/login');
                registerApiCall.run({
                    'post': {
                        api_auth: {
                            session_token: rememberLogin.session_token,
                            session_company_id: rememberLogin.session_company_id,
                        }
                    },
                    'done': function (apiReply) {
                        store.commit('logInCompanyFromApi', apiReply);
                        //store.commit('logInUser', apiReply.user);
                        //store.commit('logInCompany', apiReply.company);
                        // store.commit('logInUiDynamicSettings', apiReply.ui_dynamic_settings)
                        // store.commit('logInPermissions', apiReply.permissions);
                        // store.commit('logInLockedMonths', apiReply.locked_months);
                        // store.commit('subscriptionStatus', apiReply.subscription_status);

                        //EventBus.$emit('logged-in', {});

                        tdLocalStorage.set('td_remember_login_new', {
                            session_token: apiReply.user.session_token,
                            session_company_id: apiReply.user.session_company_id,
                        });

                        if(apiReply.subscription_status  === 'blocked' && !to.path.includes('/checkout/') && to.path !== '/checkout' && !to.path.includes('/invoices/view'))
                        {
                          router.push('/checkout');
                          next(false);
                        }else{
                          next();
                        }

                    }.bind(this),
                    'error': function (errorApiReply) {
                        //alert('Login Error');

                        console.log("Invalid user credentials. Redirecting to login");
                        tdLocalStorage.delete('td_remember_login_new'); //clear the remember login
                        router.push('/login'); // or auto login!
                        next(false);
                    }
                });

            } else {
                // we don't have any stored login information, redirect to login and stop navigation
                //skip logOutRoute because it has its own redirect
                if (to.name !== 'logOutRoute') {
                    if (to.fullPath !== '') {
                        store.commit('redirectAfterLoginToUrl', to.fullPath);
                    }
                    console.log('Login required');
                    router.push('/login'); // or auto login!
                    next(false);

                } else {
                    //logOutRoute has its own redirect
                    next();
                }

            }



        } else {
            if(store.getters.getSubscriptionStatus === 'blocked' && !to.path.includes('/checkout/') && to.path !== '/checkout'  && !to.path.includes('/invoices/view'))
            {
                // allow access to /settings/billing if online_payment is unlocked
                if (to.path === '/settings/billing' && store.getters.getAvailableFeatures.features_settings.online_payment.unlock === true) {
                    next();
                } else {
                    router.push('/checkout');
                    next(false);
                }
            } else {

                let pathsToRestrict = [
                    '/dashboard',
                    '/activity',
                    '/workSchedule',
                    '/usersManager',
                    '/projects',
                    '/general_documents',
                    '/general_reminders',
                    '/importer',
                    '/reports',
                    '/settings',
                    '/user/'
                ];

                if (store.getters.getAvailableFeatures.features_settings.iflow_clocking_routes.unlock === false) {
                    let isRestricted = false;

                    for (let pathToRestrict of pathsToRestrict) {
                        if (to.path.includes(pathToRestrict)) {
                            isRestricted = true;
                            break;
                        }
                    }

                    if (isRestricted === true) {
                        router.push('/moduleDisabled');
                        next(false);
                    } else {
                        next();
                    }
                } else {
                    if (from.path === '/login' || from.path.includes('/login')) {
                        EventBus.$emit('logged-in', {});
                    }
                    next();
                }
            }
        }
    }
});


Vue.directive('visible', (el, binding) => {
    el.style.visibility = !!binding.value ? 'visible' : 'hidden'
});


Vue.config.productionTip = false;

//translations
Vue.prototype.$tdTranslations = tdTranslations;
Vue.prototype.$tdTranslationsEventTypes = tdTranslationsEventTypes;
Vue.prototype.$__ = translate;
Vue.prototype.$ev__ = translateEventTypes;

// Register a global custom directive called v-focus
Vue.directive('focus', {
    // When the bound element is inserted into the DOM...
    inserted: function (el) {
        // Focus the element
        el.focus()
    }
});

/* eslint-disable no-new */
window.vue = new Vue({
    el: '#app',
    router, // echivalent router:router in ES6 - injecteaza router-ul in toate instnatele de componente se poate accesa cu $this->$router ?cred
    store,

    template: '<App/>',
    components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js